import React, { useState } from "react"
import styled from "styled-components"
import { Row, Col } from "react-bootstrap"

const NewsLetter = () => {
  const [validated, setValidated] = useState(false)

  const [email, setEmail] = useState("")
  const [loading, setLoading] = useState(false)
  const [serverState, setServerState] = useState({
    submitting: false,
    status: null,
    pcolor: "red",
  })
  const handleServerResponse = (ok, msg, form) => {
    setLoading(false)
    if (!ok) {
      setServerState({
        submitting: false,
        status: { ok, msg },
        pcolor: "#ffabab",
      })
    }
    if (ok) {
      setServerState({
        submitting: true,
        status: { ok, msg },
        pcolor: "darkgreen",
      })
    }
  }

  const handleSubmit = evt => {
    const form = evt.currentTarget
    if (form.checkValidity() === false) {
      evt.preventDefault()
      evt.stopPropagation()

      setValidated(true)
    } else {
      setLoading(true)

      evt.preventDefault()
      var xhr = new XMLHttpRequest()
      var url =
        "https://api.hsforms.com/submissions/v3/integration/submit/6592433/79cbb2ec-256a-479b-9e74-4c3e213cfd9e"
      var data = {
        fields: [
          {
            name: "email",
            value: email,
          },
        ],
        context: {
          pageUri: "www.azszero.com",
          pageName: "azszero-NL",
        },
      }
      //   console.log(data)
      var final_data = JSON.stringify(data)

      xhr.open("POST", url)
      // Sets the value of the 'Content-Type' HTTP request headers to 'application/json'
      xhr.setRequestHeader("Content-Type", "application/json")

      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {
          handleServerResponse(true, "Submitted Successfully!", form)
        } else {
          handleServerResponse(
            false,
            "The Emal was not submitted, Please try again.",
            form
          )
        }
      }
      // Sends the request
      xhr.send(final_data)
    }
  }

  return (
    <>
      <DivBG>
        <Row className="mx-auto text-center">
          <Col sm={3}></Col>
          <Col sm={6}>
            <StyledH1>
              Be the first to know with the latest strategies for serious Amazon
              sellers!
            </StyledH1>
          </Col>
          <Col sm={3}></Col>
        </Row>
        <Row className="mx-auto text-center">
          <Col sm={3}></Col>

          <Col xxl={6} className="pb-3">
            <EmailCollectorInput
              data-input-landing-page=""
              placeholder="Enter your email address"
              type="email"
              id="email"
              name="email"
              autocomplete="on"
              placeholder="me@domain.com"
              defaultValue=""
              onChange={e => setEmail(e.target.value)}
            />
          </Col>
          <Col sm={3}></Col>
          <Row className="mx-auto text-center">
            <Col sm={3}></Col>

            <Col xxl={6}>
              <form onSubmit={handleSubmit}>
                <StyledButton
                  className="btn"
                  type="submit"
                  style={{ marginTop: "10px" }}
                  disabled={loading}
                >
                  Subscribe
                </StyledButton>
              </form>
              <Row className="mx-auto text-center">
                <Col>
                  {serverState.status && (
                    <StyledP
                      className={!serverState.status.ok ? "errorMsg" : ""}
                      style={{ color: serverState.pcolor }}
                    >
                      {serverState.status.msg}
                    </StyledP>
                  )}
                </Col>
              </Row>
            </Col>
            <Col sm={3}></Col>
          </Row>
        </Row>
      </DivBG>
    </>
  )
}

const StyledP = styled.p`
  color: darkgreen;
  font-weight: bold;
  font-size: "large";
`

const StyledH1 = styled.h1`
  color: white;
  align-items: center;
  margin-top: 25px;
`

const DivBG = styled.div`
  height: 350px;
  background-image: url(data:image/svg+xml;base64,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);
`

const EmailCollectorInput = styled.input`
  outline: 0;
  font: 400 14px/16px Axiforma, Arial, serif;
  color: #4a4a4a;
  max-height: 50px;
  padding: 20px 46px 18px;
  background: no-repeat 17px 15px/16px 16px, #fff;
  background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMC4xMjE0IDAuODc4MTkyQzguOTQ5NzggLTAuMjkzMzgxIDcuMDUwMjkgLTAuMjkzMzgyIDUuODc4NzEgMC44NzgxOTFMMC44NzY3MjUgNC44ODAxOEMwLjI5MTMyIDUuNDY1NTggMC4wMDAzODA5OTMgNi4yMzI3MyAwIDdWMTRDMCAxNS4xMDQ2IDAuODk1NDMxIDE2IDIgMTZIMTRDMTUuMTA0NiAxNiAxNiAxNS4xMDQ2IDE2IDE0VjdDMTYuMDAwMSA2LjIzMjA4IDE1LjcwNzMgNS40NjQxMyAxNS4xMjE0IDQuODc4MjJMMTAuMTIxNCAwLjg3ODE5MlpNMTMuMTYzIDUuODYzNzdMNy45OTk5MyA4Ljg0NDY0TDIuODM2MDIgNS44NjMyNUw3LjI5MjkzIDIuMjk4OTdDNy42ODM0NSAxLjkwODQ1IDguMzE2NjIgMS45MDg0NSA4LjcwNzE0IDIuMjk4OTdMMTMuMTYzIDUuODYzNzdaTTE0LjAwMDggNy42ODk0Nkw4LjUxMTQ2IDEwLjg1ODdDOC40ODg0NCAxMC44NzI0IDguNDY0OTIgMTAuODg1MSA4LjQ0MDk3IDEwLjg5NjhDOC4zMTA4OCAxMC45NjA5IDguMTcyNjggMTAuOTk0MSA4LjAzNTI1IDEwLjk5ODhDNy44NTM5MSAxMS4wMDU0IDcuNjY4NTggMTAuOTYyNyA3LjQ5OTg0IDEwLjg2NTNMMiA3LjY4OTk3VjE0SDE0TDE0LjAwMDggNy42ODk0NloiIGZpbGw9IiNGRDcxQUYiLz4KPC9zdmc+Cg==);

  border-radius: 4px;
  width: 350px;
  border: 0;
  box-shadow: 0 10px 25px rgb(0 0 0 / 15%);
  border-left: 5px solid #413d7d;
`

const StyledButton = styled.button`
  text-transform: capitalize;
  outline: 0;
  cursor: pointer;
  margin: 25px 0;
  position: relative;

  font: 800 14px/16px Axiforma, Arial, serif;
  min-width: 138px;
  max-width: -webkit-fit-content;
  max-width: fit-content;
  max-width: -moz-fit-content;
  width: 100%;
  height: 50px;
  border-radius: 4px;
  box-shadow: 0 10px 25px rgb(123 104 238 / 50%);

  transition: 0.2s;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;

  margin: 0 auto;
  padding: 2px 30px 0;
  border-radius: 4px;
  /* color: #fff; */
  border: 1px solid #7b68ee;
  background: #615fda;

  .btn__text {
    color: #fff;
  }

  & :hover {
    background: #6b68ee;
    font-size: large;
  }
`
export default NewsLetter
